import BrandAsset from './BrandAsset'

export default class BrandsAsset {
  constructor(obj) {
    this.brands = []

    if (obj.brands && obj.brands.length > 0) {
      this.brands = obj.brands.map(brand => {
        return new BrandAsset(brand)
      })
    }
  }
}
